/* © CNES */

import { QueryFunctionContext } from '@tanstack/react-query';
import { apiConfiguration } from '../APIConfiguration';
import { authenticationAPI } from '../authentication/AuthenticateAPI';
import { handleHttpError } from '../common';
import responseUrlMock from '../mock/response_user_filters.json';

/**
 * add new filter
 * @param param0 payload for new filter
 * @returns
 */
export const addFilter = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, payload, navigate, setError400] = queryKey;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(`${apiConfiguration.apiBaseUrl}/context/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authenticationAPI.getAuthorizationHeaders(),
      },
      body: JSON.stringify(payload).replaceAll('\\', ''),
    });
    handleHttpError(res, navigate, setError400);
  } else {
    res = new Response(JSON.stringify({ test: 'OK' }));
  }
  return res?.json();
};

/**
 * update existing filter
 * @param param0 filter to update
 * @returns
 */
export const updateFilter = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, payload, navigate, setError400] = queryKey;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(
      `${apiConfiguration.apiBaseUrl}/context/filter/${payload.name}?user=${payload.user}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...authenticationAPI.getAuthorizationHeaders(),
        },
        body: JSON.stringify(payload).replaceAll('\\', ''),
      }
    );
    handleHttpError(res, navigate, setError400);
  } else {
    res = new Response(JSON.stringify({ test: 'OK' }));
  }
  return res?.json();
};

/**
 * fetch all filters by user
 * @param param0 params for API
 * @returns list of filter
 */
export const getFiltersByUser = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, params, navigate, setError400] = queryKey;

  if (process.env.NODE_ENV === 'production') {
    res = await fetch(
      `${apiConfiguration.apiBaseUrl}/context/filter/findForUser?user=${params.userEmail}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...authenticationAPI.getAuthorizationHeaders(),
        },
      }
    );
    handleHttpError(res, navigate, setError400);
  } else {
    res = new Response(JSON.stringify(responseUrlMock));
  }
  return res?.json();
};

/**
 * delete filter
 * @param param0 payload for delete filter
 * @returns
 */
export const deleteFilter = async ({
  queryKey,
}: QueryFunctionContext<any>): Promise<any> => {
  let res: Response | undefined;
  const [, payload, navigate, setError400] = queryKey;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(
      `${apiConfiguration.apiBaseUrl}/context/filter/deleteSelectedFilters?user=${payload[0].user}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          ...authenticationAPI.getAuthorizationHeaders(),
        },
        body: JSON.stringify(payload).replaceAll('\\', ''),
      }
    );
    handleHttpError(res, navigate, setError400);
  } else {
    res = new Response(JSON.stringify({ test: 'OK' }));
  }
  return res?.json();
};
